import { camelizeKeys } from 'humps';

import {
  PROCEED_TO_TREK_PAYMENT,
  CHANGE_TREK_PAYMENT_TYPE,
  STORE_TREK_PAYMENT_DETAILS,
  CHANGE_TREK_TEMPLATE_START_DATE,
  SEARCH_FLIGHTS_IN_SELF_GUIDED_TREKS,
  STORE_FLIGHTS_FOR_SELF_GUIDED_TREKS,
  CHANGE_TREK_PAYMENT_NUMBER_OF_PEOPLE,
  LOADING_STATE_FOR_TREK_REVIEW,
  UPDATE_NUMBER_OF_PORTER,
  SELECT_GUIDE_TYPE,
  STORE_NO_FLIGHTS,
} from './types';
import { history } from '../store';

import { getCustomToast } from '../../components/ErrorMessage';

import api from '../../lib/api';
import makeUrl from '../../lib/makeUrl';
import endpoints from '../../lib/endpoints';

export const changeTrekTemplateStartDate = date => ({
  type: CHANGE_TREK_TEMPLATE_START_DATE,
  trekStartDate: date,
});

export const proceedToTrekPayment = () => ({
  type: PROCEED_TO_TREK_PAYMENT,
});

export const changeTrekPaymentType = type => ({
  type: CHANGE_TREK_PAYMENT_TYPE,
  payload: type,
});

export const changeNumberOfPeople = num => ({
  type: CHANGE_TREK_PAYMENT_NUMBER_OF_PEOPLE,
  noOfPeople: num,
});

export const storeTrekPaymentDetails = data => ({
  type: STORE_TREK_PAYMENT_DETAILS,
  payload: data,
});

export const updateNumberOfPorter = noOfPorter => ({
  type: UPDATE_NUMBER_OF_PORTER,
  noOfPorter,
});

export const storeNoFlights = () => ({
  type: STORE_NO_FLIGHTS,
  outbound: {},
  inbound: {},
  tripType: 'R',
  sessionId: null,
  isFlightsAvailable: false,
});

export const selectGuideType = selectedGuideType => ({
  type: SELECT_GUIDE_TYPE,
  selectedGuideType,
});

export const searchFlights = (onSuccess, onFailure) => ({
  type: SEARCH_FLIGHTS_IN_SELF_GUIDED_TREKS,
  onSuccess,
  onFailure,
});

export const storeFlights = (
  outbound,
  inbound,
  tripType,
  isFlightsAvailable,
  sessionId
) => ({
  type: STORE_FLIGHTS_FOR_SELF_GUIDED_TREKS,
  outbound,
  inbound,
  tripType,
  isFlightsAvailable,
  sessionId,
});

export const setLoadingState = loadingState => ({
  type: LOADING_STATE_FOR_TREK_REVIEW,
  loadingState,
});

// ----------------------------------------
// THUNKS
// ---------------------------------------

export const getTrekPaymentDetails = id => async (dispatch, getState, api) => {
  try {
    const { data } = await api.getTrekPaymentReview({ trekId: id });
    dispatch(storeTrekPaymentDetails(camelizeKeys(data)));
  } catch (err) {
    getCustomToast('Cannot fetch review data. Please refresh the page.', 'error');
  }
};

export const bookGuidedTrek = data => async (dispatch, getState) => {
  const { name, id, region } = getState().selectedTrek.trek;

  const { paymentPlan: payment_plan, pax, promocode } = data;
  const invoice = {
    trek: { payment_plan, pax, id },
    guided: [],
    ...(promocode && { promocode }),
  };

  const {
    data: {
      invoices: [invoiceId],
    },
  } = await api.postWithoutToken(endpoints.invoice.create, invoice);

  const baseUrl = makeUrl.trekOverview(name, id, region);
  const url = `${baseUrl}/guided-trek/payment/${invoiceId}`;
  history.push(url);
};



// WEBPACK FOOTER //
// ./src/redux/actions/trekPaymentReviewActions.js